import { graphql, useStaticQuery } from "gatsby"

export const useContactImage = () => {
  return useStaticQuery(
    graphql`
      {
        contactImage: contentfulLandingPage {
          contactImage {
            gatsbyImageData(
              placeholder: BLURRED
              width: 1620
              height: 676
              quality: 100
            )
          }
        }
      }
    `
  )
}
